import clsx from 'clsx';

const EmailIcon = ({ className }: { className?: string }) => (
  <svg
    className={clsx(className, 'fill-current')}
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 2.25C2.5875 2.25 2.25 2.5875 2.25 3V4.03594L10.3359 10.6734C11.3062 11.4703 12.6984 11.4703 13.6688 10.6734L21.75 4.03594V3C21.75 2.5875 21.4125 2.25 21 2.25H3ZM2.25 6.94687V15C2.25 15.4125 2.5875 15.75 3 15.75H21C21.4125 15.75 21.75 15.4125 21.75 15V6.94687L15.0938 12.4125C13.2937 13.8891 10.7016 13.8891 8.90625 12.4125L2.25 6.94687ZM0 3C0 1.34531 1.34531 0 3 0H21C22.6547 0 24 1.34531 24 3V15C24 16.6547 22.6547 18 21 18H3C1.34531 18 0 16.6547 0 15V3Z" />
  </svg>
);
export default EmailIcon;
